// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatList_noChats__hWRsD {
  margin-left: 16px;
}

.ChatList_table__yXnc4 {
  width: 100%;
  border: 1px solid #EAEDF0;
  background-color: #FFFFFF;
  border-collapse: collapse;
}

.ChatList_tableHeader__6ECdQ {
  text-align: left;
  background-color: #F5F7F9;
  font-size: 12px;
}

.ChatList_columnHeader__UBjwN {
  padding: 16px 24px;
}

.ChatList_singleRow__SmlpU {
  border-bottom: 1px solid #EAEDF0;
}
.ChatList_singleRow__SmlpU > td {
  padding: 16px 24px;
}

.ChatList_modalWrapper__WU7FO {
  display: flex;
  justify-content: center;
}

.ChatList_modalInnerContainer__9wTG2 {
  display: flex;
  justify-content: center;
  align-self: center;
  height: max-content;
  background-color: #FFFFFF;
  padding: 24px;
  border-radius: 12px;
  position: relative;
}
@media (max-width: 1024px) {
  .ChatList_modalInnerContainer__9wTG2 {
    padding: 16px;
  }
}

.ChatList_title__JX52X {
  font-size: 18px;
  font-weight: 600;
}

.ChatList_subTitle__h3Hxj {
  font-size: 16px;
  color: #555F6D;
  margin-top: 4px;
  margin-bottom: 32px;
}

.ChatList_close__cNnQY {
  position: absolute;
  width: 40px;
  height: 40px;
  top: 24px;
  right: 24px;
  background-color: transparent;
  border: 1px solid #CFD6DD;
  border-radius: 8px;
}

.ChatList_textField__lPyNV {
  margin-top: 8px;
  width: 304px;
  border-radius: 8px;
  border: 1px solid #555F6D;
  height: 40px;
  padding: 0 7px;
  box-sizing: border-box;
}
@media (max-width: 1024px) {
  .ChatList_textField__lPyNV {
    width: 280px;
  }
}

.ChatList_createButtonContainer__\\+fsfX {
  margin-top: 16px;
  margin-bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/ChatList/ChatList.module.scss","webpack://./src/styles/colors.scss","webpack://./src/styles/responsive.scss"],"names":[],"mappings":"AAGA;EACI,iBAAA;AAFJ;;AAMA;EACI,WAAA;EACA,yBAAA;EACA,yBCXI;EDYJ,yBAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,yBCGM;EDFN,eAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,gCAAA;AAHJ;AAII;EACA,kBAAA;AAFJ;;AAMA;EACI,aAAA;EACA,uBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBC1CI;ED2CJ,aAAA;EACA,mBAAA;EAKA,kBAAA;AAPJ;AExCQ;EFmCR;IAUQ,aAAA;EADN;AACF;;AAKA;EACI,eAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,cCtDQ;EDuDR,eAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AAFJ;AE9EQ;EFyER;IAUQ,YAAA;EADN;AACF;;AAIA;EACI,gBAAA;EACA,kBAAA;AADJ","sourcesContent":["@use '../../styles/colors' as colors; \n@use '../../styles/responsive' as rwd;\n\n.noChats {\n    margin-left: 16px;\n}\n\n\n.table {\n    width: 100%;\n    border: 1px solid colors.$defaultAPP;\n    background-color: colors.$white;\n    border-collapse: collapse;\n}\n\n.tableHeader {\n    text-align: left;\n    background-color: colors.$neutral;\n    font-size: 12px;\n}\n\n.columnHeader {\n    padding: 16px 24px;\n}\n\n.singleRow {\n    border-bottom: 1px solid colors.$defaultAPP;\n    > td {\n    padding: 16px 24px;\n    }\n}\n\n.modalWrapper {\n    display: flex;\n    justify-content: center;\n}\n\n.modalInnerContainer {\n    display: flex;\n    justify-content: center;\n    align-self: center;\n    height: max-content;\n    background-color: colors.$white;\n    padding: 24px;\n    border-radius: 12px;\n\n    @include rwd.breakpoint(small) {\n        padding: 16px;\n    }\n    position: relative;\n}\n\n.title {\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.subTitle {\n    font-size: 16px;\n    color: colors.$secondary;\n    margin-top: 4px;\n    margin-bottom: 32px;\n}\n\n.close {\n    position: absolute;\n    width: 40px;\n    height: 40px;\n    top: 24px;\n    right: 24px;\n    background-color: transparent;\n    border: 1px solid colors.$action;\n    border-radius: 8px;\n}\n\n.textField {\n    margin-top: 8px;\n    width: 304px;\n    border-radius: 8px;\n    border: 1px solid colors.$secondary;\n    height: 40px;\n    padding: 0 7px;\n    box-sizing: border-box;\n\n    @include rwd.breakpoint(small) {\n        width: 280px;\n    }\n}\n\n.createButtonContainer {\n    margin-top: 16px;\n    margin-bottom: 8px;\n}","$white: #FFFFFF;\n\n$primary: #272E35;\n\n$grey4: #DEE3E7;\n$secondary: #555F6D;\n$whitealfa: #9E9E9E;\n$emerald5: #F4EAD7;\n$emerald7: #F8F6F1;\n\n$green0: #0EB77A;\n$green4: #08200D;\n$green5: #E1F9F0;\n\n// APP\n$secondaryAPP: #D8F8E7;\n$primaryAPP: #1D7C4D;\n$primaryGreenAPP: #086E49;\n$action: #CFD6DD;\n$surface: #FCFCFD;\n$neutral: #F5F7F9;\n$raspberry: #FBD5E2;\n$greenAPP: #C6F1DA;\n$defaultAPP: #EAEDF0;","@mixin breakpoint($point) {\n    @if $point == small {\n        @media (max-width:  1024px) { @content; }\n    }\n    // @else if $point == medium {\n    //     @media (min-width:  769px) and (max-width: 1280px) { @content; }\n    // }\n    @else if $point == large {\n        @media (min-width:  1025px) { @content; }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noChats": `ChatList_noChats__hWRsD`,
	"table": `ChatList_table__yXnc4`,
	"tableHeader": `ChatList_tableHeader__6ECdQ`,
	"columnHeader": `ChatList_columnHeader__UBjwN`,
	"singleRow": `ChatList_singleRow__SmlpU`,
	"modalWrapper": `ChatList_modalWrapper__WU7FO`,
	"modalInnerContainer": `ChatList_modalInnerContainer__9wTG2`,
	"title": `ChatList_title__JX52X`,
	"subTitle": `ChatList_subTitle__h3Hxj`,
	"close": `ChatList_close__cNnQY`,
	"textField": `ChatList_textField__lPyNV`,
	"createButtonContainer": `ChatList_createButtonContainer__+fsfX`
};
export default ___CSS_LOADER_EXPORT___;
